import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CadeResourceModal from '../CadeResource/CadeResourceModal';
import CadeComponentHeader from './CadeComponentHeader';
import CadeComponentDoodle from './CadeComponentDoodle';
import CadeComponentDesc from './CadeComponentDesc';
import CadeInputRaterComment from './CadeInputRaterComment';
import CadeDomainItems from './CadeDomainItems';

import Tour from '../../productTour/Tour';

import ReactPlayer from 'react-player';

import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';

import './CadeInput.css';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class CadeInputComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            assessmentId: props.assessmentId,
            selectedIndex: props.selectedIndex,
            cadeMode: props.cadeMode,
            cadeDomainId: 0,
            cadeDomain: props.cadeDomain,
            domainDisplayName: props.domainDisplayName,
            clearDesc: null,
            userDesc: null,
            domainImage: props.cadeDomain + "LG.png",
            userDomainDesc: null,
            domainResources: [], 
            items: [],
            resId: 0,            // Resource management
            resName: null, 
            resDesc: null,
            resType: 0,
            resUri: null,
            resDict: null,
            cgComments: null,
            r1Comments: null,
            r2Comments: null,
            readonly: false,
            dynamicItemChange: 0
        }

        // Save processing:  change handler records changes as they are made.  When the user changes from this component, saveHandler is called and will 
        // use the itemResponses dictionary to update the DB.
        this.requiresSave = false; 
        this.itemsToSave = [];  // Array of objects of the form {assessmentItemId, cadeAiUserResponse, caregiverResponse, rater1Response, rater2Response, partnerProviderResponse}
    }

    buildResourceDict = (domainResources, items) => {
        /*
         * Put all resource, for either the domain or for the items into an dictionary of  objects having the form { id, resourceObj }.
         * The dictionary key is the id = 0 for the domain and the positive itemId for all items.
         * ResourceObj is the resource object({ id, name, description, type, uri }) returned from the api call.
         * 
         * HandleResIconClick(id, type) does the heavy lifting by scanning this dictionary to find the appropriate resource and then setting
         * the state(id, type, name, description, uri) appropriately.
         */

        let resDict = new Map();    // Javascript's idea of a dictionary

        // Add the domain resources first
        resDict.set(0, domainResources);

        // Now iterate the items, adding their resources if they have any
        let itemRes = null;
        for (let i = 0; i < items.length; i++) {
            itemRes = items[i].resources;
            if (isNullOrEmpty(itemRes)){
                continue;
            }
            resDict.set(items[i].itemDefId, itemRes);
        }

        return resDict;
    }

    handleResIconClick = (key, resType) => {
        // Given a key, find a resource of the given resType and then set it's attributes in state
        let resources = this.state.resDict.get(key);
        let res = null;
        if (!isNullOrEmpty(resources)) {
            res = this.getResourceOfType(resources, resType);
            if (res != null) {
                this.setState({
                    resId: res.id,
                    resName: res.name,
                    resDesc: res.description,
                    resType: res.type,
                    resUri: res.uri
                })
            }
        }
    }

    getResourceOfType = (resArray, type) => {
        //  is an array of resource objects of the form {id, name, etc.}}
        let res = null;
        if (!isNullOrEmpty(resArray)) {
            for (let i = 0; i < resArray.length; i++) {
                if (resArray[i].type == type) {
                    res = resArray[i];
                    break;
                }
            }
        }
        return res;
    }

    handleResModalClose = () => {
        this.setState({ resType: 0 });
    }

    nextDomain = () => {
        this.props.nextDomain();
    }

    prevDomain = () => {
        this.props.prevDomain();
    }

    onChangeHandler = (assessmentItemId, isCaregiverResponse, isRater1Response, isRater2Response, isRater3Response, isPartnerProviderResponse, event) => {
        this.requiresSave = true;

        // Items contains both item definitions and responses.  Modify the correct element's cadeAiUserResponse property with the new value.
        let newItems = [...this.state.items];
        let stateNeedsUpdated = false;
        let navUpdate = null;
        for (let i = 0; i < newItems.length; i++) {
            if (newItems[i].assessmentItemId == assessmentItemId) {
                if (isCaregiverResponse || isRater3Response) {
                    // Rater3 responses map onto caregiver.  Just a name change.
                    newItems[i].caregiverResponse = event.target.value;
                    // Just in case it's a rater 3
                    newItems[i].rater3Id = authService.authenticatedUserName;
                    stateNeedsUpdated = true;
                }
                else if (isRater1Response)
                {
                    newItems[i].rater1Response = event.target.value;
                    newItems[i].rater1Id = authService.authenticatedUserName;
                    stateNeedsUpdated = true;
                }
                else if (isRater2Response) {
                    newItems[i].rater2Response = event.target.value;
                    newItems[i].rater2Id = authService.authenticatedUserName;
                    stateNeedsUpdated = true;
                }
                else if (isPartnerProviderResponse) {
                    newItems[i].partnerProviderResponse = event.target.value;
                    newItems[i].partnerProviderId = authService.authenticatedUserId;
                    stateNeedsUpdated = true;
                }
                else {
                    newItems[i].cadeAiUserResponse = event.target.value;
                    stateNeedsUpdated = true;
                    navUpdate = event.target.value;
                }
                
                // Record a new item in the local cache (used by the save api) and then update the state
                this.itemsToSave.push({
                    AssessmentItemId: assessmentItemId,
                    CadeAiUserResponse: newItems[i].cadeAiUserResponse,
                    CaregiverResponse: newItems[i].caregiverResponse,
                    Rater1Response: newItems[i].rater1Response,
                    Rater1Id: newItems[i].rater1Id,
                    Rater2Response: newItems[i].rater2Response,
                    Rater2Id: newItems[i].rater2Id,
                    Rater3Id: newItems[i].rater3Id,
                    PartnerProviderResponse: newItems[i].partnerProviderResponse,
                    PartnerProviderId: newItems[i].partnerProviderId,
                    ResponderType: authService.userType
                });

                break;
            }
        }

        if (stateNeedsUpdated) {
            this.setState({ items: newItems });
        }

        if (navUpdate != null) {
            this.props.navUpdateHandler(navUpdate);
        }
    }

    commentChangeHandler = (ut, comment) => {
        // Save the comment
        let url = "/assessment/" + this.state.assessmentId + "/domain/" + this.state.cadeDomainId + "/comment";
        api.post(url, 
            {
                AssessmentId: this.state.assessmentId,
                DomainId: this.state.cadeDomainId,
                UserType: ut,
                Comment: comment
            },
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {
                if (response.status == 200) {
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                };
            })
            .catch((error) => {
                apiErrorPopup(apiErrorHandler(error));
            });
    }


    saveHandler = () => {

        if (this.requiresSave) {
            // Save everything in the itemResponses dictionary to the database.
            let url = "/assessment/" + this.state.assessmentId + "/item";  
            api.post(url, {
                ItemResponses: this.itemsToSave
            },
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {
                if (response.status == 200) {
                    this.requiresSave = false;

                    // Replace the navMarkers with a new set if returned
                    if (!isNullOrEmpty(response.data)) {
                        // Add the navMarker definition as a javascript dictionary
                        let markerMap = new Map();
                        for (let i = 0; i < response.data.length; i++) {
                            markerMap.set(response.data[i].domainName, response.data[i].navMarker);
                        }
                        this.props.navMarkersHandler(markerMap);
                    }
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                };
            })
            .catch((error) => {
                // Major problem - should not happen.  Back to login?
                apiErrorPopup(apiErrorHandler(error));
            });
        }
    }

    componentDidMount = () => {
        /*
         * Run a query to get the domain's input for the given assessment id (in props):
         * Domain Name
         * Clear description
         * User description
         * Doodle
         * Domain Resources
         * domainItems -  (ordered area of itemDefs AND associated responses).  
         */

        // Need to provide the user type cc, pp, cg, r1, r2
        let userType = authService.userType;

        let url = "assessment/" + this.state.assessmentId + "/domain/" + this.state.cadeDomain + "/" + this.state.cadeMode + "/" + userType + "/uid/" + authService.authenticatedUserId;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status === 200) {
                // Build the resource dictionary used to lookup resource clicks.
                let resDict = this.buildResourceDict(response.data.domainResources, response.data.domainItems);

                this.setState({
                    cadeDomainId: response.data.domainId,
                    cadeDomain: response.data.domainName,
                    domainDisplayName: response.data.domainDisplayName,
                    clearDesc: response.data.domainDescription,
                    userDesc: null,
                    domainImage: response.data.domainImageName,
                    domainResources: response.data.domainResources,
                    items: response.data.domainItems,
                    resDict: resDict,
                    cgComments: response.data.caregiverComments,
                    r1Comments: response.data.rater1Comments,
                    r2Comments: response.data.rater2Comments,
                    readonly: response.data.authenticatedUserReadonly,
                    dynamicItemChange: response.data.dynamicItemChange
                });
            }
        })
        .catch(error => {
            // Major problem - should not happen.  Back to login?
            apiErrorPopup(apiErrorHandler(error))
        });
    }

    render() {
        let subTitle = "Assessment Domain Input";
        let whoFor = authService.userType;
        let comment = null;

        switch (whoFor) {
            case 3:
                // caregiver
                comment = this.state.cgComments;
                break;

            case 4:
                // r1
                comment = this.state.r1Comments;
                break;

            case 5:
                // r2
                comment = this.state.r2Comments;
                break;

            case 6:
                // r3 - use caregiver comment since r3 is name change only
                comment = this.state.cgComments;
                break;

            default:
                // can't happen
                break;
        }

        let numDynChanges = Math.abs(this.state.dynamicItemChange);
        let dynChangeLessMore = (this.state.dynamicItemChange < 0) ? "less" : "more";
        let dynChangeVerb = (this.state.dynamicItemChange > 1) ? "are" : "is";
        let dynChangeNoun = (this.state.dynamicItemChange > 1) ? "items" : "item";

        return (
            <Fragment>
                <Tour
                    name="Input"
                    key="Input"
                />
                <Container fluid >
                    <Row>
                        <Col sm={4}>
                            <CadeComponentHeader 
                                cadeDomain={this.state.domainDisplayName}
                                subTitle={subTitle}
                                />
                        </Col>
                        {false &&
                            <Col className="cadeComponent_videoHelp" sm={8}>
                                <Row>
                                    <Col className="cadeComponent_videoCol" sm={6}>
                                        <h6>Using CADE's Input Pages</h6>
                                        <div class="cadeComponent_playerWrapper">
                                            <ReactPlayer className="cadeComponent_player" url='https://vimeo.com/391572395/674dcbc1c3' controls={true} width='100%' height="100%" />
                                        </div>
                                    </Col>

                                    <Col className="cadeComponent_videoCol" sm={6}>
                                        <h6>Getting Help Answering</h6>
                                        <div class="cadeComponent_playerWrapper">
                                            <ReactPlayer className="cadeComponent_player" url='https://vimeo.com/392051020/39dd7bd77e' controls={true} width='100%' height="100%" />
                                        </div>
                                    </Col>
                                </Row>
                                {!authService.isRaterOrCaregiver &&
                                    <Row>
                                        <Col className="cadeComponent_videoCol" sm={6}>

                                            <h6>Inviting Rater Input</h6>
                                            <div class="cadeComponent_playerWrapper">
                                                <ReactPlayer className="cadeComponent_player" url='https://vimeo.com/391588689/3d67d76020' controls={true} width='100%' height="100%" />
                                            </div>
                                        </Col>
                                        <Col className="cadeComponent_videoCol" sm={6}>
                                            <h6>Understanding Other Input</h6>
                                            <div class="cadeComponent_playerWrapper">
                                                <ReactPlayer className="cadeComponent_player" url='https://vimeo.com/391583003/ba8365242d' controls={true} width='100%' height="100%" />
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        }
                    </Row>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentDoodle
                                domainImage={this.state.domainImage}
                                resClickHandler={this.handleResIconClick}
                                resources={this.state.domainResources}
                                resKey={0}
                            />
                        </Col>
                        <Col sm={8}>
                            <CadeComponentDesc
                                title="Clear Child Domain Description"
                                desc={this.state.clearDesc}
                                titleIcon={null}
                            />
                        </Col>
                    </Row>
                    {this.state.dynamicItemChange > 0 &&
                        <Row>
                            <Col sm={4}>
                            </Col>
                            <Col sm={8}>
                            <span className="cadeInput_DynItemChange">
                                There {dynChangeVerb} {numDynChanges} {dynChangeLessMore} assessment {dynChangeNoun} in this domain than in the prior assessment due to CADE's intelligent assessment technology.  Because of this, you may notice unanticipated differences in analysis and progress results.
                                </span>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col sm={12}>
                            <p> </p>
                            <span className="cadeInput_RequiredItem">All items must be answered. Responses are automatically saved.</span>
                        </Col>
                    </Row>
                    <Row >
                        <Col sm={12}>
                            <CadeDomainItems
                                assessmentId={this.state.assessmentId}
                                cadeDomain={this.state.cadeDomain}
                                items={this.state.items}
                                isCaregiver={authService.isCaregiver}
                                isRater1={authService.isRater1}
                                isRater2={authService.isRater2}
                                isRater3={authService.isRater3}
                                isPartnerProvider={authService.isPartnerProvider}
                                selectedIndex={this.state.selectedIndex}
                                resClickHandler={this.handleResIconClick}
                                changeHandler={this.onChangeHandler}
                                saveHandler={this.saveHandler}
                                nextDomain={this.nextDomain}
                                prevDomain={this.prevDomain}
                                numUnanswered={this.props.numUnanswered}
                                readonly={this.state.readonly}
                            />
                        </Col>
                    </Row>
                    <Row>
                        {authService.isCaregiverOrRater &&
                            <Col sm={12}>
                                <CadeInputRaterComment
                                whoFor={whoFor}
                                comment={comment}
                                commentChangeHandler={this.commentChangeHandler}
                                key={this.state.cadeDomainId+this.state.whoFor+comment}
                                />
                            </Col>
                        }
                    </Row>
                </Container>

                <CadeResourceModal
                    domainName={this.state.domainDisplayName}
                    resName={this.state.resName}
                    resDesc={this.state.resDesc}
                    resType={this.state.resType}
                    resUri={this.state.resUri}
                    modalCloseHandler={this.handleResModalClose}
                />
            </Fragment>
        )
    }
}

export default CadeInputComponent;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeInputComponent.js